import { Button } from '@civilgrid/ui/components';
import { useEffect, useState } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { useSnapshot } from 'valtio';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import Rotation from '~/components2/Map/Widgets/Rotation';
import rootStore from '~/store';
import store from '../store';
import { PrintViewScale } from './PrintViewScale';

export default function ControlButtons() {
  const [canvas, setCanvas] = useState<HTMLElement>();
  const { current: mapRef } = useMap();
  const map = mapRef?.getMap();
  const { currentMap, currentMapId, projectId } = useSnapshot(store) as typeof store;

  useEffect(() => {
    const surface = document.getElementById('surface-base');
    if (surface) {
      setCanvas(surface);
    }
  }, []);

  function print() {
    if (canvas && map) {
      const mapCanvas = map.getCanvas();
      const dims = {
        width: Number(mapCanvas.getAttribute('width')),
        height: Number(mapCanvas.getAttribute('height')),
      };
      const originalMapStyles = mapCanvas.style.cssText;
      const originalCanvasStyles = canvas.style.cssText;

      if (dims.width >= dims.height) {
        const aspectRatio = dims.width / dims.height;
        mapCanvas.style.width = '100vw';
        mapCanvas.style.height = `calc(${mapCanvas.style.width} / ${aspectRatio})`;
        canvas.style.width = '100vw';
        canvas.style.height = `calc(${mapCanvas.style.width} / ${aspectRatio})`;
      } else if (dims.height > dims.width) {
        const aspectRatio = dims.width / dims.height;
        mapCanvas.style.height = '100vh';
        mapCanvas.style.width = `calc(${mapCanvas.style.height} * ${aspectRatio})`;
        canvas.style.height = '100vh';
        canvas.style.width = `calc(${mapCanvas.style.height} * ${aspectRatio})`;

        // shift positioning so the map is centered on the page.
        const mapWidth = mapCanvas.style.width;
        mapCanvas.style.marginLeft = `calc((100vw - ${mapWidth}) / 2)`;
        canvas.style.marginLeft = `calc((100vw - ${mapWidth}) / 2)`;
      }

      window.print();

      // reset styles to their original prior to printing.
      mapCanvas.style.cssText = originalMapStyles;
      canvas.style.cssText = originalCanvasStyles;

      // store.projectId (URL param) is set immediately; project.id is async-loaded.
      if (projectId) {
        captureTypedPosthogEvent(POSTHOG_EVENTS.projectCivildrawPrintCreated, {
          project_id: projectId,
          organization_id: rootStore.currentOrganizationId || undefined,
          print_format: 'browser_print',
          ...(currentMapId && { map_id: currentMapId }),
        });
      }
      return;
    }
  }

  return (
    <div className="absolute right-4 top-4 flex space-x-2">
      {mapRef && currentMap && <PrintViewScale />}
      <Rotation />
      <div className="print:hidden">
        <Button
          variant="secondary"
          data-testid="civildraw-print-exit"
          onClick={() => {
            store.printView = false;
            window.document.exitFullscreen();
          }}
        >
          Exit Print View
        </Button>
        <Button variant="secondary" data-testid="civildraw-print-button" onClick={print}>
          Print
        </Button>
      </div>
    </div>
  );
}
